module.exports = __webpack_public_path__ + "static/img/73_bells.6639e09a.jpg";